import React from 'react'
import CrudApi from './PracticeSet/crudApicall/CrudApi';
import { BrowserRouter, Routes, Route  } from "react-router-dom";
import Read from './PracticeSet/read/Read';
import Edit from './PracticeSet/edit/Edit';
import NewPortfolio from './components/porfolio_updated/NewPortfolio';
const Router = () => {
  return (
    <div>   
    
            <Routes>
                <Route  path="/crud" element={<CrudApi/>}></Route>
                <Route  path="/read" element={<Read/>}></Route>
                <Route  path="/porfolio" element={<NewPortfolio/>}></Route>
                <Route  path="/edit" element={<Edit/>}></Route>
            </Routes>
    </div>
  )
}

export default Router
